<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-time`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_40c123182d__clip0_271_29173)"><path d="M8.00076 0.334961C12.2338 0.335374 15.6658 3.76782 15.6658 8.00098C15.6654 12.2338 12.2336 15.6656 8.00076 15.666C3.76757 15.666 0.335103 12.2341 0.33474 8.00098C0.33474 3.76757 3.76735 0.334961 8.00076 0.334961ZM8.00076 1.66895C4.50373 1.66895 1.66872 4.50395 1.66872 8.00098C1.66909 11.4977 4.50395 14.332 8.00076 14.332C11.4972 14.3316 14.3314 11.4974 14.3318 8.00098C14.3318 4.5042 11.4974 1.66936 8.00076 1.66895ZM7.79372 3.91016C8.16185 3.91018 8.46066 4.20901 8.46072 4.57715C8.46074 4.76265 8.46068 5.81125 8.46072 6.86914C8.46074 7.41894 8.46579 7.57955 8.50173 7.72168C8.53785 7.8643 8.59709 8.00082 8.67751 8.12402C8.75768 8.24666 8.87306 8.35904 9.27712 8.73145L10.0877 9.47852C10.3583 9.72806 10.3752 10.1502 10.1258 10.4209C9.87628 10.6913 9.45501 10.7082 9.18435 10.459L8.3738 9.71191C8.01878 9.38471 7.75342 9.14668 7.5613 8.85254C7.40042 8.60607 7.281 8.33415 7.20876 8.04883C7.12261 7.70824 7.12675 7.35189 7.12673 6.86914C7.12669 5.81105 7.12676 4.7623 7.12673 4.57715C7.12673 4.209 7.42557 3.91021 7.79372 3.91016Z"/></g><defs><clipPath id="svg_40c123182d__clip0_271_29173"><path d="M0 0H16V16H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconLineTime',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
